/** An empty table reads differently depending on why it is empty, so each reason gets its own case. */
export type OutreachRequestsEmptyStateVariant = 'noClient' | 'noRequests' | 'noMatches' | 'error';

type VariantParams = {
    hasSelectedClient: boolean;
    hasFilters: boolean;
    isError: boolean;
};

// Without a client the list never asks for anything, so nothing can have failed yet.
export function getEmptyStateVariant({
    hasSelectedClient,
    hasFilters,
    isError,
}: VariantParams): OutreachRequestsEmptyStateVariant {
    if (!hasSelectedClient) {
        return 'noClient';
    }

    if (isError) {
        return 'error';
    }

    if (hasFilters) {
        return 'noMatches';
    }

    return 'noRequests';
}
